if (!customElements.get('related-products-slider')) {
  customElements.define(
    'related-products-slider',
    class RelatedProductsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        if (!this.querySelector('.swiper-slide')) return;
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.related-products-swiper');
        if (!swiperEl || this.swiper) return;

        const mobileSingle = this.dataset.mobileSingleCard === 'true';
        const mobileSlides = mobileSingle ? 1 : 2;

        try {
          this.swiper = new Swiper(swiperEl, {
            slidesPerView: mobileSlides,
            spaceBetween: 12,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1025: {
                slidesPerView: 4,
                spaceBetween: 12,
              },
            },
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              type: 'fraction',
            },
            navigation: {
              nextEl: this.querySelector('.related-products-next'),
              prevEl: this.querySelector('.related-products-prev'),
            },
          });
        } catch (error) {
          console.error('Error initializing Related Products Swiper:', error);
        }
      }
    },
  );
}
